import {
  CertificateVariant,
  CourseCertificateImage,
  CourseObject,
  CourseProfileAttributes,
} from "@api/types/course-completion";

export function certificateImage(course: CourseObject, variant: string) {
  if (!course.courseCertificateImage) {
    return null;
  }

  return course.courseCertificateImage.find(
    (ci: CourseCertificateImage) => ci.variant.toLowerCase() === variant.toLowerCase()
  );
}

export function profileAttributes(course: CourseObject, variant: string) {
  if (!course.profileAttributes) {
    return null;
  }

  return course.profileAttributes.find(
    (pa: CourseProfileAttributes) => pa.registrationAttributeValue.toLowerCase() === variant.toLowerCase()
  );
}

export function certificateVariant(course: CourseObject, variant: string, type: string, delivery: string) {
  const pa = profileAttributes(course, variant);
  if (!pa) {
    return null;
  }

  return pa.certificateVariants.find(
    (cv: CertificateVariant) =>
      cv.type.toLowerCase() === type.toLowerCase() && cv.delivery.toLowerCase() === delivery.toLowerCase()
  );
}
